import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import getConfig from 'next/config';

import 'dayjs/locale/de-ch';
import 'dayjs/locale/fr-ch';

const {publicRuntimeConfig: config} = getConfig();
const TZ = 'Europe/Zurich';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.locale(config.localeCode.toLowerCase());
dayjs.tz.setDefault('UTC');

const matchIso8601 = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})((?:\+|-)\d{2}:(\d{2}))/;
const matchUtc = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z/;

const formatIso8601 = 'YYYY-MM-DDTHH:mm:ssZ';
const formatUtc = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

/**
 * normalize / format date strings to utc
 *
 * @param input datetime string
 */
export const normalizeDate = (input: string) => {
    if (matchUtc.test(input)) {
        return input;
    }

    if (matchIso8601.test(input)) {
        return new Date(input).toISOString();
    }

    return dayjs.tz(input, TZ).utc().format(formatUtc);
};

/**
 * format a utc datetime string to any format
 *
 * @param input normalized utc datetime string
 * @param format date format pattern
 */
export const utcToFormat = (input: string, format: string) => {
    if (!input) {
        return '';
    }

    // workaround bug in day.js
    const date = dayjs(input)
        .tz(TZ)
        .format(formatIso8601)
        .substr(0, formatIso8601.length - 1);

    return dayjs.tz(date, TZ).format(format);
};

/**
 * takes a normalized time string and returns a locally formatted ISO string
 *
 * @param input normalized utc datetime string
 */
export const utcToIso8601 = (input: string) => {
    return utcToFormat(input, formatIso8601);
};
